import axios from 'axios';

const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;

class SherlockService {
    search(data) {
        return axios.post(API_URL+'sherlock/user-info', data);
    }
    urlToBase64(data) {
        return axios.post(API_URL+'convert-base64/', data);
    }
}

export default new SherlockService();
